import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {VendorsTable} from "./components/VendorsTable";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getVendors} from "../../store/reducers/VendorsSlice";
import {VendorSearch} from "./components/VendorsSearch";
import {useParams} from "react-router-dom";
import Pagination from "../common/Pagination";

interface VendorsScreenProps {
}

export const VendorsScreen: React.FC<VendorsScreenProps> = () => {

    const dispatch = useAppDispatch();
    const routeParams = useParams();

    const vendorsState = useAppSelector(state => state.vendors);

    useEffect(() => {
        dispatch(getVendors());
    }, [routeParams]);

    return (
        <LoggedInView fullWidth={false}>
            <VendorSearch />
            <VendorsTable />
            <Pagination totalItems={vendorsState.total} itemsPerPage={30} />
        </LoggedInView>
    )

}